import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ShareOutOfBox({ idVariant = '', className }: Props) {
  return (
    <IconBase name="share-out-of-box" w={24} className={className}>
      <path
        d="M8.5 11H6V20H18V11H15.5V9H18C19.1046 9 20 9.89543 20 11V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V11C4 9.89543 4.89543 9 6 9H8.5V11ZM16.707 6.29297L15.293 7.70703L13 5.41406V14H11V5.41406L8.70703 7.70703L7.29297 6.29297L12 1.58594L16.707 6.29297Z"
        fill="currentColor"
      />
    </IconBase>
  )
}

export default ShareOutOfBox
